import { observer } from 'mobx-react-lite';
import UIBuilderPage from './UIBuilderPage';
import { UIBuilderPageProps, UIBuilderPageValueProps } from './types';

export type { UIBuilderPageProps, UIBuilderPageValueProps };
export default observer(UIBuilderPage); // MANUAL OVERRIDE
